'use client'

import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { useLanguage } from '@contexts/LanguageContext'

const HeroSection: React.FC = () => {
  const { t } = useLanguage()
  const [currentSlide, setCurrentSlide] = useState(0)

  const slides = [
    {
      title: t('heroTitle1'),
      subtitle: t('heroSubtitle1'),
      image: '/banner/IMG_2412.jpg',
    },
    {
      title: t('heroTitle2'),
      subtitle: t('heroSubtitle2'),
      image: '/banner/IMG_2423.jpg',
    },
    {
      title: t('heroTitle3'),
      subtitle: t('heroSubtitle3'),
      image: '/banner/IMG_4241.jpg',
    },
    {
      title: t('heroTitle1'),
      subtitle: t('heroSubtitle1'),
      image: '/banner/IMG_4244.jpg',
    },
    {
      title: t('heroTitle2'),
      subtitle: t('heroSubtitle2'),
      image: '/banner/IMG_4371.jpg',
    },
    {
      title: t('heroTitle3'),
      subtitle: t('heroSubtitle3'),
      image: '/banner/IMG_4411.jpg',
    },
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 6000)
    return () => clearInterval(timer)
  }, [slides.length])

  return (
    <section className="hero-modern">
      {/* Background Slider */}
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="hero-overlay-gradient"></div>
          </div>
        ))}
      </div>
      {/* Content */}
      <div className="hero-container">
        <div className="hero-content-wrapper">
          <h1 className="hero-title-modern">{slides[currentSlide].title}</h1>
          <p className="hero-subtitle-modern">{slides[currentSlide].subtitle}</p>

          {/* CTA Buttons */}
          <div className="hero-cta-group">
            <Link href="/donate" className="btn-primary-large">
              <span className="btn-icon">❤️</span>
              <span className="btn-text">
                <strong>{t('donateNow')}</strong>
                <small>{t('makeImpactToday')}</small>
              </span>
            </Link>
            <Link href="/projects" className="btn-secondary-large">
              <span className="btn-text">
                <strong>{t('viewPrograms')}</strong>
                <small>{t('seeWhereWeWork')}</small>
              </span>
              <span className="btn-arrow">→</span>
            </Link>
          </div>
        </div>

        {/* Slider Navigation */}
        <div className="hero-slider-nav">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <span>{t('scrollToExplore')}</span>
      </div>
    </section>
  )
}

export default HeroSection
